import styled, { css } from 'styled-components'

//import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout'

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NetworkAPContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
`

export const NetworkAPHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
`

export const HomeConfigurationWhiteBlock = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const NavigateToMistButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
`

export const NavigateToMistForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
`
